
export const Logout = () => {

    return (
        <div>
            <h1>Logout</h1>
        </div>
    )

}